import React, { useEffect, useRef } from "react";
import "./GranFormato.css";
import emailjs from '@emailjs/browser';


const GranFormato = () => {
    const bannerRef = useRef(null);

    useEffect(() => {
        window.scrollTo({
            top: 0,
            left: 0,
            behavior: 'smooth'
        });
    }, []);

    useEffect(() => {
        const observer = new IntersectionObserver(
            ([entry]) => {
                if (entry.isIntersecting) bannerRef.current.classList.add("visible");
            },
            { threshold: 0.3 }
        );
        if (bannerRef.current) observer.observe(bannerRef.current);
    }, []);

    return (
        <section className="granformato">
            {/* === SECCIÓN 1: Banner con animación === */}
            <div className="granformato-banner" ref={bannerRef}>
                <img src="/images/granformato/nube1.png" alt="nube" className="nube nube1" />
                <img src="/images/granformato/nube2.png" alt="nube" className="nube nube2" />
                <img src="/images/granformato/espectacular.png" alt="espectacular" className="espectacular" />
                <div className="banner-texto">
                    <h3>Impresión en <br></br><span className="bold">GRAN FORMATO</span></h3>
                    <img src="/images/logo/MotiPuntos.svg" style={{ height: '0.7rem' }}></img>
                    <p>Innovación en cada solución</p>
                </div>
            </div>

            {/* === SECCIÓN 2: Texto + Imagen edificio === */}
            <div className="granformato-info">
                <p className="subtitle">we make it <span>happen.</span></p>

                <div className="info-contenido">
                    <div className="info-texto">
                        <div className="tag"> <img src="/images/granformato/edificio.svg" style={{ height: '1rem' }}></img> Gran formato</div>
                        <h2>
                            Tu mensaje a lo grande con nuestra<br></br> impresión en
                            <span> gran formato</span>
                        </h2>
                        <p>
                            Desde la <b>proyección hasta la instalación</b>, ofrecemos impresión de gran formato de alta calidad para cualquier superficie.
                            Trabajamos con marcas <b>Fortune 500</b>, creando soluciones impactantes en <b>fachadas, toldos, letreros neón, lonas y más.</b>
                        </p>
                        <p className="cta">
                            En Moti Digital lo hacemos posible, <a href="#cotiza">solicita tu cotización:</a>
                        </p>
                        <div className="input-wrapper">
                            <form
                                onSubmit={async (e) => {
                                    e.preventDefault();
                                    const form = e.target;
                                    const button = form.querySelector("button");
                                    const input = form.querySelector("input");

                                    button.disabled = true;
                                    const originalText = button.textContent;
                                    button.textContent = "Enviando...";

                                    try {
                                        const serviceID = "service_lxg5sht";
                                        const templateID = "template_epehkcc";
                                        const publicKey = "4f0iRLKGvmXsd0ASA";

                                        const params = {
                                            from_name: input.value, 
                                            message: `Me interesan sus productos de Gran formato. Me pueden contactar al correo ${input.value}, me estoy contactando desde motidigital.com `,
                                        };

                                        console.log("📤 Enviando con EmailJS...");
                                        console.log({ serviceID, templateID, publicKey, params });

                                        const res = await emailjs.send(serviceID, templateID, params, publicKey);
                                        console.log("✅ Respuesta EmailJS:", res);

                                        if (res.status === 200) {
                                            button.textContent = "Enviado ✔";
                                            input.value = "";
                                            setTimeout(() => {
                                                button.textContent = originalText;
                                                button.disabled = false;
                                            }, 3000);
                                        } else {
                                            throw new Error("Error en el envío");
                                        }
                                    } catch (error) {
                                        console.error("❌ Error al enviar con EmailJS:", error);

                                        button.textContent = "Error ✖";
                                        setTimeout(() => {
                                            button.textContent = originalText;
                                            button.disabled = false;
                                        }, 2500);
                                    }
                                }}
                            >
                                <input
                                    type="email"
                                    name="email"
                                    placeholder="Tu correo electrónico"
                                    required
                                />
                                <button type="submit">Empecemos</button>
                            </form>

                        </div>

                    </div>

                    <div className="info-imagen">
                        <img src="/images/granformato/edificio-banner.png" alt="Gran formato en edificio" />
                    </div>
                </div>
            </div>
            <div className="granformato-final">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="dots" />
                <h2>
                    ¿Listo para hacer crecer <br />
                    <span>tu empresa?</span>
                </h2>

                {/* Doble marquee - VERSIÓN SIMPLE */}
                <div className="granformato-marquees">
                    <div className="marquee line1">
                        <span>
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                        </span>
                        <span>
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                            IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN · IMPRESIÓN EN ·
                        </span>
                    </div>

                    <div className="marquee line2">
                        <span>
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                        </span>
                        <span>
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                            GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO · GRAN FORMATO ·
                        </span>
                    </div>
                </div>


                {/* Slider semicircular */}
                <div className="granformato-slider">
                    <div className="slider-track">
                        <img src="/images/granformato/slider/1.png" alt="img1" />
                        <img src="/images/granformato/slider/2.png" alt="img2" />
                        <img src="/images/granformato/slider/3.png" alt="img3" />
                        <img src="/images/granformato/slider/4.png" alt="img4" />
                        <img src="/images/granformato/slider/5.png" alt="img5" />
                    </div>
                </div>
            </div>
            {/* === SECCIÓN 3: Opción estratégica === */}
            <div className="granformato-opcion">
                <img src="/images/logo/Moti Logo.svg" alt="decorativo" className="opcion-icon" />

                <div className="opcion-card">
                    <div className="opcion-left">
                        <h2>Somos tu<br></br> opción estratégica</h2>
                        <p>Innovación y calidad<br></br>en cada material</p>
                        <button className="btn-cotizar">Cotizar ahora</button>
                    </div>

                    <div className="opcion-right">
                        <div className="opcion-item">
                            <div className="icon" style={{ backgroundColor: "#f7c19a" }}>
                                <img src="/images/granformato/variedad.svg" alt="Variedad" />
                            </div>
                            <div>
                                <h4>Variedad</h4>
                                <p>Contamos con más de 100 telas, lonas y viniles diferentes, ofreciendo soluciones innovadoras para punto de venta, materiales publicitarios, branding y diseño.</p>
                            </div>
                        </div>

                        <div className="opcion-item">
                            <div className="icon" style={{ backgroundColor: "#c9e7e4" }}>
                                <img src="/images/granformato/personalizacion.svg" alt="Personalización" />
                            </div>
                            <div>
                                <h4>Personalización</h4>
                                <p>Gracias a nuestra impresión de alta calidad y combinación ilimitada de colores, garantizamos que la identidad de tu marca se mantenga intacta.</p>
                            </div>
                        </div>

                        <div className="opcion-item">
                            <div className="icon" style={{ backgroundColor: "#e8c7d4" }}>
                                <img src="/images/granformato/sostenibilidad.svg" alt="Sostenibilidad" />
                            </div>
                            <div>
                                <h4>Sostenibilidad</h4>
                                <p>Nuestros materiales son ECO-FRIENDLY y tienen un ancho máximo de 3.2 metros, adaptándose a tus necesidades sin comprometer la calidad.</p>
                            </div>
                        </div>
                    </div>
                </div>
            </div>
            <div className="granformato-faq">
                <img src="/images/logo/MotiPuntos.svg" alt="puntos" className="dots" />
                <h2>Preguntas frecuentes</h2>
                <div className="faq-contenedor">
                    {/* Lado izquierdo - Acordeón */}
                    <div className="faq-lista">
                        <details open>
                            <summary>¿Cuentan con servicio de instalación?</summary>
                            <p>
                                Sí, contamos con un equipo especializado que puede instalar en cualquier parte de la República Mexicana.
                                Consulta con un ejecutivo de cuenta para cotizar este servicio.
                            </p>
                        </details>

                        <details>
                            <summary>¿Tienen opciones de impresión con datos variables?</summary>
                            <p>
                                Sí, realizamos impresión personalizada con datos variables para proyectos que requieren información única
                                en cada pieza.
                            </p>
                        </details>

                        <details>
                            <summary>¿Cuál es el tamaño máximo para impresiones en gran formato?</summary>
                            <p>
                                Contamos con equipos que imprimen hasta 3.2 metros de ancho, manteniendo una calidad de impresión óptima.
                            </p>
                        </details>

                        <details>
                            <summary>¿Los materiales son eco–friendly?</summary>
                            <p>
                                Sí, trabajamos con materiales sostenibles y tintas ecológicas que reducen el impacto ambiental.
                            </p>
                        </details>

                        <details>
                            <summary>¿Ofrecen servicios de diseño?</summary>
                            <p>
                                Por supuesto. Nuestro equipo creativo puede ayudarte a desarrollar tu diseño desde cero o adaptar tus
                                archivos existentes.
                            </p>
                        </details>
                    </div>

                    {/* Lado derecho - Contacto */}
                    <div className="faq-contacto">
                        <h3>¿Tienes más dudas?</h3>
                        <p>No dudes en contactarnos para más información.</p>

                        <div className="contacto-email">
                            <div className="email-box">
                                <img src="/images/granformato/mail.svg" alt="email" />
                                <span>COTIZACIONES@MOTIDIGITAL.COM</span>
                                <button>Agendar una llamada</button>
                            </div>
                            <button className="btn-whatsapp"> Cotiza tu proyecto</button>
                        </div>

                        <div className="faq-img">
                            <img src="/images/granformato/faq-banner.png" alt="FAQ" />
                        </div>
                    </div>
                </div>
            </div>

        </section>

    );
};

export default GranFormato;
